import api from '@/services/api'

export default {
    signUp(user, checkoutSessionId = null) {
        var urlString = 'session/';
        if (checkoutSessionId)
            urlString += `${checkoutSessionId}/`
        return api.post(urlString, {
            first_name: user.firstName,
            last_name: user.lastName,
            email: user.email,
            password: user.password
        }, {withCredentials: true})
        .then(response => response.data);
    },
    createSpot(data, checkoutSessionId, csrf) {
        var formData = new FormData();
        formData.set('client_name', data.clientName);
        formData.set('business_name', data.businessName);
        formData.set('phone_number', data.phone);
        formData.set('image', data.fileImage);
        formData.set('address', data.address);
        formData.set('line_of_work', data.lineWork);
        formData.set('short_description', data.shortDescription);
        formData.set('website', data.website);
        var config = {
            withCredentials: true,
            headers: {
                "X-CSRFToken": csrf
            }
        }
        return api.post(`spot/${checkoutSessionId}/`, formData, config)
            .then(response => response.data);
    },
    getStripeSession(checkoutSessionId, csrf) {
        var config = {
            withCredentials: true,
            headers: {
                "X-CSRFToken": csrf
            }
        }
        return api.post(`checkout/session/${checkoutSessionId}/`, {}, config)
            .then(response => response.data);
    },
    login(email, password) {
        return api.post(`session/login`, { email, password }, { withCredentials: true })
            .then(response => response.data);
    },
    logout() {
        return api.put('session/')
            .then(response => response.data);
    },
    completeCheckoutSession(checkoutSessionId, csrf) {
        var config = {
            withCredentials: true,
            headers: {
                "X-CSRFToken": csrf
            }
        }
        return api.put(`checkout/session/${checkoutSessionId}/`, {}, config)
            .then(response => response.data);
    },
    updateAd(data, csrf) {
        var formData = new FormData();
        formData.set('client_name', data.clientName);
        formData.set('business_name', data.businessName);
        formData.set('phone_number', data.phone);
        formData.set('image', data.fileImage);
        formData.set('address', data.address);
        formData.set('line_of_work', data.lineWork);
        formData.set('short_description', data.shortDescription);
        formData.set('website', data.website);
        var config = {
            withCredentials: true,
            headers: {
                "X-CSRFToken": csrf
            }
        }
        return api.put(`spot/`, formData, config)
            .then(response => response.data);
    },
    getSpot(csrf) {
        var config = {
            withCredentials: true,
            headers: {
                "X-CSRFToken": csrf
            }
        }
        return api.get(`spot/user/`, config)
            .then(response => response.data);
    },
    getInvoices(csrf) {
        var config = {
            withCredentials: true,
            headers: {
                "X-CSRFToken": csrf
            }
        }
        return api.get('invoices/', config)
            .then(response => response.data);
    },
    updateAccount(csrf, email, firstName, lastName, password, newPassword, confPassword) {
        var config = {
            withCredentials: true,
            headers: {
                "X-CSRFToken": csrf
            }
        }
        return api.put('user/', {
            first_name: firstName,
            last_name: lastName,
            email: email,
            curr_password: password,
            new_password: newPassword,
            password_confirmation: confPassword
        }, config)
            .then(response => response.data);
    }
}